<app-slide-in-modal #modal>
  <ng-container title i18n>Modifier une demande</ng-container>
  <div body>
    <app-lead-form
      #leadForm
      [customerId]="userId"
      [memberId]="memberId"
      formId="editLeadForm"
      [(isSubmitted)]="isSubmitted"
      (formSubmit)="updateLead($event)"
      [lead]="lead"
      *ngIf="ready"
    />
    <div *ngIf="!ready" class="d-flex justify-content-center p-4">
      <div class="spinner-border" role="status"></div>
    </div>
  </div>
  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      i18n
    >
      Annuler
    </button>
    <button
      form="editLeadForm"
      type="submit"
      [disabled]="!leadForm?.formGroup?.valid || leadForm?.isSubmitted"
      class="lty-btn lty-btn-primary"
      i18n
    >
      Sauvegarder
    </button>
  </div>
</app-slide-in-modal>
